import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from '../../assest/images/logo.png';
import { Link } from 'react-router-dom';

import Style from '../Styles/DashboardStyle.module.css';
import Button from '../Styles/Button.module.css';
import { MdNotifications, MdHelpOutline, MdOutlineHome  } from "react-icons/md";
const DashboardTitle = (props)=>{
    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };
    return( 
            <Row>
                <Col className={Style.flexHead}>
                    <h2 className={Style.DashboardTitle}>{props.title}</h2>
                    <div className={Style.memberBtn}>
                        {props.membertype ?( <Link to="/">
                            <p><img src="https://mayoalumni.in/images/non-member-img.png" alt=""/>  {props.membertype}</p>
                        </Link>):null
                        }
                        <Link to="/donate" className={Style.greenBtn}>DONATE</Link>
                    </div>
                </Col>
          </Row>
        )
    }
    
    export default DashboardTitle;